var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CashCardContent',{attrs:{"message":_vm.order.payments[0].data.message}})}
var staticRenderFns = []

export { render, staticRenderFns }